import type { Course } from "@brookbush/types";

type Props = {
	course: Course;
};

const CourseCreditInformation = ({ course }: Props) => {
	return (
		<div className="mx-auto flex flex-col items-center gap-4 sm:gap-6">
			<h2 className="font-semibold text-2xl sm:text-2xl">Credits</h2>

			<div className="mx-auto flex flex-wrap items-center justify-center gap-4">
				<span
					id="course-credits"
					className="max-w-max rounded-full border border-emerald-600/10 bg-emerald-200 phablet:px-3.5 px-3 py-0.5 font-semibold phablet:text-base text-emerald-900 dark:text-emerald-900"
				>
					{course.credits} Credit{course.credits >= 2 ? "s" : ""}
				</span>{" "}
				{course?.linkedCertifications?.map((certification) => (
					<span
						key={certification._id}
						className="max-w-max rounded-full border border-amber-600/10 bg-amber-100 phablet:px-3.5 px-2.5 py-0.5 font-semibold phablet:text-base text-amber-900 dark:text-amber-900"
					>
						{certification.title}
					</span>
				))}
				<span className="max-w-max rounded-full border border-sky-600/10 bg-sky-100 phablet:px-3.5 px-2.5 py-0.5 font-semibold phablet:text-base text-sky-900 dark:text-sky-900">
					Continuing Education
				</span>
			</div>
		</div>
	);
};

export default CourseCreditInformation;
